import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import axios from './axios';
import tracker from './utils/tracker';
import './styles/fonts.css'; // 引入字体样式文件

// 加载字体
loadFonts();

// 创建全局对象并挂载到 Vue 原型上
const globalObject = {
    typeId: null,
    id: null,
    index: null,
    audio: null,
    image:null
  };

const globalUrl = 'https://sunosong.cn/musicPlayer';

// 从单独文件导入音乐类型映射，按需加载
import { genreMap, genreMapReversed } from './utils/genreMaps';

// 创建全局的 Audio 对象并挂载到 Vue 原型上
const app = createApp(App);
app.config.globalProperties.$globalAudio = new Audio();
app.config.globalProperties.$globalObject = globalObject;
app.config.globalProperties.$axios = axios; 
app.config.globalProperties.$globalUrl = globalUrl;
app.config.globalProperties.$genreMap = genreMap;
app.config.globalProperties.$genreMapReversed = genreMapReversed;
app.config.globalProperties.$tracker = tracker;



// 注册点击事件埋点指令
app.directive('track', {
  mounted(el, binding) {
    el.addEventListener('click', () => {
      const { value: eventName, arg: targetId } = binding;
      const targetText = el.textContent || el.innerText;
      
      tracker.trackClick(
        targetId || el.id || el.className,
        targetText.trim(),
        eventName
      );
    });
  }
});

// 使用 router 和 vuetify 插件
app.use(router).use(vuetify);

// 挂载到 DOM
app.mount('#app');